import React from "react";

const DashboardCard = ({ title, value, image }) => {
  return (
    <div className="w-full h-40 sm:h-40 pl-2 pr-2 sm:pl-4 sm:pr-4">
      <div className="bg-white w-full h-full p-4 rounded-3xl flex flex-col justify-between shadow-md">
        <span className="text-xs sm:text-sm text-[#718EBF] leading-snug">
          {title}
        </span>

        <div className="flex items-center gap-2 sm:gap-4">
          <div className="bg-[#FFF8E6] w-12 h-12 sm:w-14 sm:h-14 flex justify-center items-center rounded-full shrink-0">
            {image && (
              <img src={image} alt="icon" className="w-6 h-6 sm:w-7 sm:h-7" />
            )}
          </div>

          <p className="text-base sm:text-2xl font-semibold text-black">
            {value}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
